export const USER_ROLE = {
  ADMIN: 'ADMIN',
  LEAD: 'LEAD',
  GUEST: 'GUEST',
  STATE_USER: 'STATE USER',
  DISTRICT_USER: 'DISTRICT USER',
  STATE_COMMISSIONER: 'SCPD',
  DISTRICT_COLLECTOR: 'DM',
  CHIEF_COMMISSIONER: 'CCPD',
  AUTHORITY_USER: 'CONCERNED AUTHORITY',
  DePWD_USER: "DEPWD",
  NODAL_OFFICER: 'NO'
};
